import { CATALOG_SITUATIONS } from "@/data/catalogScenarios";
import { findCatalogSituation, type CatalogSituation } from "./catalog";
import { sceneDebrief, type SceneDebrief } from "./missions";
import { fallbackAnalysis, isTooShortForFeedback, type SessionAnalysis } from "./sessionAnalysis";
import { UNCERTAIN_COACH } from "./sceneCast";

export type ReviewDebrief = SceneDebrief;

export function shouldInvokeAnalyzer(status: string | null | undefined): boolean {
  return status !== "ready" && status !== "too_short";
}

export function buildPersistedSessionFields(catalogSlug: string | undefined, userTurns: number) {
  const tooShort = isTooShortForFeedback(userTurns);
  const situation = findCatalogSituation(CATALOG_SITUATIONS, catalogSlug);
  return {
    tooShort,
    status: tooShort ? "too_short" : "analyzing",
    analysis: fallbackAnalysis({
      userTurns,
      situationTitle: situation?.title,
      nextSlug: catalogSlug,
      uncertain: true,
    }),
  };
}

export function reviewDebrief(
  situation: CatalogSituation | undefined,
  analysis: SessionAnalysis,
): ReviewDebrief {
  if (situation) return sceneDebrief(situation, analysis);
  const stuck = analysis.stuck?.trim() || "";
  const trusted = analysis.uncertain !== true && stuck.length > 0 && !analysis.tooShort;
  return {
    handled: analysis.handled || "",
    stuck: trusted ? stuck : "",
    coachLine: analysis.coachLine || analysis.summary || UNCERTAIN_COACH,
    repaired: analysis.repaired,
    trusted,
  };
}
